import { defineMessages } from 'react-intl';

const messages = defineMessages({
    moduleLearningObjectives: {
        id:'moduleLearningObjectives',
        defaultMessage: `{itemCount, plural,
            one {Core concept}
            other {Core concepts}}`,
        description: 'Heading for list of module learning objectives',
    },
    curriculumOverviewPageError: {
        id:'curriculumOverviewPageError',
        defaultMessage: 'Unable to load data for the provided curriculum\'s overview.',
        description: 'Error message for curriculum overview page',
    },
    curriculumTopicPageSidebarError: {
        id:'curriculumTopicPageSidebarError',
        defaultMessage: 'Unable to load data for the provided curriculum.',
        description: 'Error message for sidebar of curriculum topic page',
    },
    curriculumModuleOverviewLink: {
        id:'curriculumModuleOverviewLink',
        defaultMessage: 'Overview',
        description: 'Link text for multiple curriculum learning objectives parent',
    },
    curriculumPageTitle: {
        id:'curriculumPageTitle',
        defaultMessage: '{name} - Curriculum overview',
        description: 'Heading for curriculum overview page',
    },
    emptyCurriculumMessage: {
        id:'emptyCurriculumMessage',
        defaultMessage: 'No curriculum found for the current grade and subject selection.',
        description: 'Message to show the user when no curriculum is found.',
    },
});

export default messages;
